import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AgendaAmbulatoriaService } from 'src/app/services/agenda-ambulatoria.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-pasarela-pago',
  templateUrl: './pasarela-pago.component.html',
  styleUrls: ['./pasarela-pago.component.scss']
})
export class PasarelaPagoComponent implements OnInit {

  @Output() public dialogEvent: EventEmitter<any> = new EventEmitter();

  idCita;
  codCita;
  pasarelaPago;

  constructor(
    @Inject(MAT_DIALOG_DATA) public inp: { idCita: any, codCita: number },
    public dialogRef: MatDialogRef<any>,
    public agendaService: AgendaAmbulatoriaService,
    public utils: UtilsService
  ) {
    this.idCita = this.inp.idCita;
    this.codCita = this.inp.codCita;
  }

  ngOnInit() {
    this.dialogEvent.emit({});
    this.dialogRef.close();
  }

}
